import { createStore, combineReducers, compose } from "redux";
import appReducer from "./app/reducer";
import crudReducer from "./crud/reducer";

const rootReducer = combineReducers({
  app: appReducer,
  crud: crudReducer,
});

let rootEnhancer = compose();
if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && process.env.NODE_ENV === "development") {
  rootEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    name: "simplebis-adminpanel",
  })(rootEnhancer);
}

const initialStore = {};
const store = createStore(rootReducer, initialStore, rootEnhancer);
export { store };
